import { fileUploadText } from './bulkImportConstants';

const MaxFileLimitReachedPopOver = ({ file }) => {
  return (
    <>
      {file && (
        <div
          className="
            pointer-events-none
            absolute bottom-full left-1/2 z-50 mb-2
            w-max -translate-x-1/2
            rounded-md bg-gray-900 px-3 py-2
            text-sm text-white
            opacity-0 invisible
            transition-all
            group-hover:opacity-100
            group-hover:visible
          "
        >
          {fileUploadText.MAX_FILE_REACHED_POPOVER_TEXT}
        </div>
      )}
    </>
  );
};

export default MaxFileLimitReachedPopOver;
